import { StyleSheet, } from '@react-pdf/renderer';

export const stylesDefensorComarca = StyleSheet.create(
  {
    page: {
      padding: 20,
      fontSize: 9,
      flexDirection: 'column',
      fontFamily: 'Helvetica',
    },
    title: {
      fontSize: 14,
      textAlign: 'center',
      marginBottom: 8,
      fontWeight: 'bold',
    },
    updated: {
      fontSize: 9,
      textAlign: 'center',
      marginBottom: 10,
      fontStyle: 'italic',
    },
    table: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      marginBottom: 15,
    },
    row: {
      flexDirection: 'row',
    },
    rowOdd: {
      flexDirection: 'row',
      backgroundColor: '#f4f4f4',
    },
    rowEven: {
      flexDirection: 'row',
      backgroundColor: '#d3d3d3',
    },
    cell: {
      padding: 4,
      flexGrow: 1,
      textAlign: 'left',
    },
    cellHeader: {
      padding: 4,
      flexGrow: 1,
      textAlign: 'center',
      backgroundColor: '#e0e6ed',
      fontWeight: 'bold',
    },
    bold: {
      fontWeight: 'bold',
    },
    comarcaTitle: {
      marginTop: 10,
      marginBottom: 4,
      fontSize: 11,
      fontWeight: 'bold',
      color: '#1f2d3d',
    },
    atuacaoTitle: {
      marginTop: 8,
      marginBottom: 4,
      fontSize: 10,
      fontWeight: 'bold',
    },
    predioTitle: {
      marginTop: 8,
      marginBottom: 4,
      fontSize: 10,
      fontWeight: 'bold',
    },
    diretoriaTitle: {
      marginTop: 8,
      marginBottom: 4,
      fontSize: 10,
      fontWeight: 'bold',
      color: '#1f2d3d',
    },
    footer: {
      borderTop: '1 solid #ccc',
      marginTop: 10,
      paddingTop: 4,
      fontSize: 9,
      textAlign: 'center',
      color: '#888',
      position: 'absolute',
      bottom: 10,
      left: 30,
      right: 30,
    },
  });